import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { OrderStatus } from '../../interfaces/order-state/order-status';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';
import { Asset } from '../../interfaces/assets/asset';
import { PatchDocument } from '../../interfaces/patch-document';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AssetRepositoryService {

  constructor(private http: HttpClient,
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig) { }

  // CRUD Operations ---------------
  public getAsset = (route: string, orderID: string) => {
    // Get Orders
    return this.http.get<OrderStatus>(
      this.createCompleteRoute(route, this.config.rootUrl));
  }

  public createAsset = (route: string, asset: Asset) => {
    return this.http.post<Asset>(
      this.createCompleteRoute(route, this.config.rootUrl),
      asset,
      this.generateHeaders());
  }
  
  public createAssets(orderID: string, assets: Asset[]) {
    return this.http.post(`${this.config.rootUrl}/Orders/${orderID}/Assets/Collection`, assets);
  }

  public updateAsset = (route: string, asset: Asset) => {
    return this.http.put(this.createCompleteRoute(route, this.config.rootUrl), asset, this.generateHeaders());
  }

  public deleteAsset = (route: string) => {
    return this.http.delete(this.createCompleteRoute(route, this.config.rootUrl));
  }
  
  public deleteAssets(orderID: string) {
    return this.http.delete(`${this.config.rootUrl}/Orders/${orderID}/Assets`);
  }

  public updatePostRegistrationSearch(orderID: string, assetID: string, val: boolean) {
    return this.patchAsset(orderID, assetID, [{ value: val, path: 'ShouldTriggerPostRegistrationSearch', op: 'replace '}]);
  }
  
  public patchAsset(orderID: string, assetID: string, patchDocument: PatchDocument[]): Observable<Asset> {
    return this.http.patch<{ resource: Asset }>(`${this.config.rootUrl}/Orders/${orderID}/Assets/${assetID}`, patchDocument)
      .pipe(map(r => r.resource));
  }

  private createCompleteRoute = (route: string, envAddress: string) => {
    return `${envAddress}/${route}`;
  }

  private generateHeaders = () => {
    return {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
  }
}
